<template>
    <a-modal
        :visible="true"
        width="70vw"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="npm-wrap"
        @cancel="handleClose"
    >
        <div class="npm-modal">
            <div class="npm-head">
                <div>
                    <h3>{{ title }}</h3>
                    <div class="npm-sub" v-if="product.pro_descricao">{{ product.pro_descricao }}</div>
                </div>
                <button class="npm-x" @click="handleClose">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <a-spin :spinning="loading">
                <div class="npm-body">
                    <div class="npm-grid">
                        <div class="npm-field npm-field-wide">
                            <label class="npm-label">Descrição <span class="npm-required">*</span></label>
                            <a-input
                                v-model="produtoModal"
                                placeholder="Digite a descrição do produto"
                                :class="{ 'npm-error': errorProdutoModal }"
                                @focus="errorProdutoModal = false"
                            />
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Categoria <span class="npm-required">*</span></label>
                            <a-select
                                :value="categoriaModal ? categoriaModal.cat_id : undefined"
                                placeholder="Selecione"
                                show-search
                                option-filter-prop="children"
                                :disabled="disabledInputs && !editProductCategoryAndIntCode"
                                :class="{ 'npm-error': errorCategoriaModal }"
                                @focus="errorCategoriaModal = false"
                                @change="onCategoryChange"
                            >
                                <a-select-option v-for="category in categories" :key="category.cat_id" :value="category.cat_id">
                                    {{ category.cat_descricao }}
                                </a-select-option>
                            </a-select>
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">
                                Código interno
                                <a-icon
                                    v-if="!isGenerico && !editProductCategoryAndIntCode"
                                    :type="edit_internal_code_allowed ? 'unlock' : 'lock'"
                                    class="npm-lock"
                                    :class="{ 'npm-lock-open': edit_internal_code_allowed }"
                                    @click="edit_internal_code_allowed = !edit_internal_code_allowed"
                                />
                            </label>
                            <a-input
                                v-model="codigoModal"
                                placeholder="Código interno"
                                :disabled="internalCodeDisabled"
                            />
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Código <span class="npm-required">*</span></label>
                            <a-input
                                v-model="codEanModal"
                                placeholder="Digite o código"
                                inputmode="numeric"
                                :disabled="disabledInputs"
                                :class="{ 'npm-error': errorCodEanModal }"
                                @focus="errorCodEanModal = false"
                                @input="handleDigitsInput($event, 'codEanModal')"
                            />
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Unidade <span class="npm-required">*</span></label>
                            <a-select
                                v-if="!isGenerico"
                                :value="wrap && wrap.value ? wrap.value : undefined"
                                placeholder="Selecione"
                                :class="{ 'npm-error': errorEmbalagemModal }"
                                @focus="errorEmbalagemModal = false"
                                @change="onWrapChange"
                            >
                                <a-select-option v-for="option in wraps" :key="option.value" :value="option.value">
                                    {{ option.name }}
                                </a-select-option>
                            </a-select>
                            <div class="npm-generic-unit" v-else>
                                <a-select
                                    v-if="!editGeneric"
                                    :value="wrap || undefined"
                                    placeholder="Selecione"
                                    :class="{ 'npm-error': errorEmbalagemModal }"
                                    @focus="errorEmbalagemModal = false"
                                    @change="(value) => (wrap = value)"
                                >
                                    <a-select-option v-for="name in genericUnitOptions" :key="name" :value="name">
                                        {{ name }}
                                    </a-select-option>
                                </a-select>
                                <a-input v-else v-model="wrap" placeholder="Digite a unidade" />
                                <a-button
                                    class="npm-icon-btn"
                                    :icon="editGeneric ? 'close' : 'edit'"
                                    @click="editGeneric = !editGeneric"
                                />
                            </div>
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Qtd. embalagem <span class="npm-required">*</span></label>
                            <a-input
                                v-model="qtdEmbalagemModal"
                                placeholder="Quantidade na embalagem"
                                inputmode="numeric"
                                :disabled="!!(wrap && (wrap.value == 'UN' || wrap.value == 'DZ' || isGenerico))"
                                :class="{ 'npm-error': errorQtdEmbalagemModal }"
                                @focus="errorQtdEmbalagemModal = false"
                                @input="handleDigitsInput($event, 'qtdEmbalagemModal')"
                            />
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Fornecedor exclusivo</label>
                            <a-select
                                :value="providerKey(selectedProvider)"
                                placeholder="Selecione"
                                show-search
                                option-filter-prop="children"
                                @change="onProviderChange"
                            >
                                <a-select-option v-for="option in providerOptions" :key="option.key" :value="option.key">
                                    {{ option.text }}
                                </a-select-option>
                            </a-select>
                        </div>

                        <div class="npm-field">
                            <label class="npm-label">Vendedor</label>
                            <a-select
                                :value="buyerKey(selectedBuyer)"
                                placeholder="Selecione"
                                :class="{ 'npm-error': selectedBuyerError }"
                                @focus="selectedBuyerError = false"
                                @change="onBuyerChange"
                            >
                                <a-select-option v-for="option in buyerOptions" :key="option.key" :value="option.key">
                                    {{ option.text }}
                                </a-select-option>
                            </a-select>
                        </div>

                        <div class="npm-field" v-if="to_request">
                            <label class="npm-label">Quantidade <span class="npm-required">*</span></label>
                            <a-input
                                v-model="produtoQuantidadeCotacaoModal"
                                placeholder="Quantidade"
                                inputmode="numeric"
                                :disabled="disabledInputs"
                                @input="handleDigitsInput($event, 'produtoQuantidadeCotacaoModal')"
                            />
                        </div>
                    </div>

                    <div class="npm-options">
                        <a-checkbox :checked="isGenerico" @change="(evt) => toggle_generic(evt.target.checked)">
                            Produto genérico
                        </a-checkbox>
                        <a-checkbox
                            :checked="!!product.pro_pedido_direto"
                            @change="(evt) => (product.pro_pedido_direto = evt.target.checked)"
                        >
                            Pedido direto
                        </a-checkbox>
                        <div class="npm-status">
                            <a-switch v-model="statusModal" />
                            <span>{{ statusModal ? "Ativo" : "Inativo" }}</span>
                        </div>
                    </div>

                    <a-alert v-if="serverMsg" type="error" :message="serverMsg" show-icon class="npm-alert" />

                    <a-table
                        v-if="!to_request"
                        class="npm-stores"
                        size="small"
                        row-key="loj_id"
                        :columns="storeColumns"
                        :data-source="stores"
                        :pagination="stores.length > items_by_page_value ? { pageSize: items_by_page_value, size: 'small' } : false"
                        :locale="{ emptyText: 'Nenhuma empresa encontrada' }"
                    >
                        <template slot="store" slot-scope="text, store">
                            {{ (store.loj_nomeFantasia || "").toUpperCase() }}
                        </template>
                        <template slot="suggestion" slot-scope="text, store">
                            <a-input
                                v-model="store.qtd_sugestao"
                                class="npm-suggestion-input"
                                inputmode="numeric"
                                placeholder="0"
                                @input="handleStoreSuggestionInput($event, store)"
                            />
                        </template>
                    </a-table>
                </div>
            </a-spin>

            <div class="npm-foot">
                <div>
                    <a-button v-if="isGenerico && product.pro_id" icon="shop" @click="showMarcas">Marcas</a-button>
                </div>
                <div class="npm-foot-actions">
                    <a-button @click="handleClose">Voltar</a-button>
                    <a-button type="primary" icon="save" :loading="loading" @click="validaFormularioCadastro">Salvar</a-button>
                </div>
            </div>
        </div>

        <ProductBrandsModal
            v-if="brands && showEditBrandsModal"
            :closeDialog="
                () => {
                    showEditBrandsModal = false;
                }
            "
            :brands="brands"
            :product="product"
        />
    </a-modal>
</template>

<script>
import axios from "axios";
import * as CONSTANTS from "@/constants/constants";
import ProductService from "@/services/ProductService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import QuotationService from "@/services/QuotationService";
import ProductBrandsModal from "@/modals/product-brands/product-brands.modal";
import SellersService from "@/services/v3/commons/sellers.service";
import ProviderService from "@/services/v3/provider.service";

const NO_PROVIDER_KEY = "__none__";
const CURRENT_PROVIDER_KEY = "__current__";

export default {
    name: "NewProductModalV2",
    components: { ProductBrandsModal },
    props: {
        product: {
            type: Object,
            required: true,
        },
        to_request: {
            type: Boolean,
            default: false,
        },
        internal_code_only: {
            type: Boolean,
            default: false,
        },
        closeDialog: {
            type: Function,
        },
        editProductCategoryAndIntCode: {
            type: Boolean,
        },
        tituloModal: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            items_by_page_value: 30,
            edit_internal_code_allowed: false,
            wraps_load: [],
            buyers: [],
            selectedBuyerError: false,
            selectedBuyer: {
                text: this.product.pro_vend_nome,
                value: { id: this.product.pro_vend_id },
            },
            wraps: [
                { name: "Atado", value: "AT" },
                { name: "Unidade", value: "UN" },
                { name: "Caixa", value: "CX" },
                { name: "Fardo", value: "FD" },
                { name: "Kilograma", value: "KG" },
                { name: "Duzia", value: "DZ" },
                { name: "Display", value: "DP" },
                { name: "Pacote", value: "PC" },
            ],
            wraps_generic: [
                { name: "Unidade", value: "UN" },
                { name: "Litro", value: "LT" },
                { name: "Kilograma", value: "KG" },
                { name: "Caixa", value: "CX" },
                { name: "Fardo", value: "FD" },
            ],
            errorProdutoModal: false,
            errorCodigoModal: false,
            editGeneric: false,
            errorEmbalagemModal: false,
            errorQtdEmbalagemModal: false,
            errorCategoriaModal: false,
            errorCodEanModal: false,
            statusModal: true,
            loading: true,
            wrap: "",
            codigoModal: "",
            produtoModal: "",
            qtdEmbalagemModal: 1,
            produtoQuantidadeCotacaoModal: 0,
            categoriaModal: "",
            unidadeModal: "",
            serverMsg: "",
            codEanModal: "",
            qtdSugestaoModal: "",
            isGenerico: false,
            arrayEmbalagem: [],
            stores: [],
            categories: [],
            brands: [],
            providers: [],
            selectedProvider: { text: this.product.pro_for_nome, value: true },
            disabledInputs: false,
            showEditBrandsModal: false,
            prodId: null,
            product_service: new ProductService(),
            psvc: new ProviderService(),
            service: new QuotationService(),
            sellers_svc: new SellersService(),
            storeColumns: [
                { title: "ID", dataIndex: "loj_id", key: "loj_id", width: 80, align: "center" },
                { title: "Empresa", key: "store", scopedSlots: { customRender: "store" } },
                { title: "Qtd. sugestão", key: "suggestion", width: 160, align: "center", scopedSlots: { customRender: "suggestion" } },
            ],
        };
    },
    computed: {
        title() {
            return this.tituloModal || (this.product.pro_id ? "Editar Produto" : "Novo Produto");
        },
        internalCodeDisabled() {
            if (this.editProductCategoryAndIntCode) return false;
            return (this.disabledInputs && !this.internal_code_only) || !this.edit_internal_code_allowed || this.isGenerico;
        },
        genericUnitOptions() {
            const names = this.wraps.map((option) => option.name);
            return this.wrap && typeof this.wrap === "string" && !names.includes(this.wrap) ? [...names, this.wrap] : names;
        },
        providerOptions() {
            const options = this.providers.map((provider) => ({ key: this.providerKey(provider), text: provider.text }));
            const current = this.providerKey(this.selectedProvider);
            if (current && !options.some((option) => option.key === current)) {
                options.unshift({ key: current, text: this.selectedProvider.text });
            }
            return options;
        },
        buyerOptions() {
            const options = this.buyers.map((buyer) => ({ key: this.buyerKey(buyer), text: buyer.text }));
            const current = this.buyerKey(this.selectedBuyer);
            if (current && !options.some((option) => option.key === current)) {
                options.unshift({ key: current, text: this.selectedBuyer.text });
            }
            return options;
        },
    },
    methods: {
        handleClose() {
            if (this.closeDialog) {
                this.closeDialog();
            } else {
                this.close();
            }
        },
        close() {
            this.$emit("close");
        },
        handleDigitsInput(event, field) {
            const value = event.target.value.replace(/\D/g, "");
            this[field] = value;
            event.target.value = value;
        },
        handleStoreSuggestionInput(event, store) {
            const value = event.target.value.replace(/\D/g, "");
            this.$set(store, "qtd_sugestao", value);
            event.target.value = value;
        },
        onCategoryChange(catId) {
            this.categoriaModal = this.get_category_by_id(catId);
        },
        onWrapChange(value) {
            this.wrap = this.get_packaging_by_code(value);
        },
        providerKey(provider) {
            if (!provider) return undefined;
            if (provider.value === null) return NO_PROVIDER_KEY;
            if (provider.value === true) return provider.text ? CURRENT_PROVIDER_KEY : undefined;
            return provider.value && provider.value.id != null ? String(provider.value.id) : undefined;
        },
        onProviderChange(key) {
            if (key === CURRENT_PROVIDER_KEY) return;
            this.selectedProvider = this.providers.find((provider) => this.providerKey(provider) === key) || null;
        },
        buyerKey(buyer) {
            if (!buyer || !buyer.value) return undefined;
            return buyer.value.id != null ? String(buyer.value.id) : NO_PROVIDER_KEY;
        },
        onBuyerChange(key) {
            this.selectedBuyer = this.buyers.find((buyer) => this.buyerKey(buyer) === key) || this.selectedBuyer;
        },
        showMarcas() {
            this.loading = true;
            this.product_service
                .get_product_brands(this.product.pro_id)
                .then((data) => {
                    this.brands = data.data.produtos;
                    this.showEditBrandsModal = true;
                    this.loading = false;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        validaFormularioCadastro() {
            if (
                this.product &&
                this.wrap &&
                this.categoriaModal &&
                this.codEanModal &&
                (this.produtoQuantidadeCotacaoModal || !this.to_request) &&
                (!this.selectedProvider || this.selectedBuyer)
            ) {
                if (this.product.pro_id) {
                    this.editarProduto();
                } else {
                    this.cadastroProduto();
                }
            } else {
                this.serverMsg = "Preencha os campos indicados acima";
            }

            if (!this.produtoModal) {
                this.errorProdutoModal = true;
            }
            if (!this.wrap) {
                this.errorEmbalagemModal = true;
            }
            if (!this.qtdEmbalagemModal) {
                this.errorQtdEmbalagemModal = true;
            }
            if (!this.categoriaModal) {
                this.errorCategoriaModal = true;
            }
            if (!this.codEanModal) {
                this.errorCodEanModal = true;
            }
            if (this.selectedProvider && !this.selectedBuyer) {
                this.selectedBuyerError = true;
            }
        },
        load_categories() {
            return this.service
                .getCategorias()
                .then((response) => response.data)
                .then((data) => {
                    this.categories = data.categorias;
                });
        },
        getListaProdutos() {
            this.$emit("reload_products");
        },
        async editarProduto() {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                };

                const isChangingToGeneric = this.product.pro_generico !== 1 && this.isGenerico;

                const data = {
                    codInterno: this.codigoModal,
                    generico: this.isGenerico ? 1 : 0,
                    pro_pedido_direto: this.product.pro_pedido_direto ? 1 : 0,
                    descricao: this.produtoModal,
                    categoria: this.categoriaModal.cat_id,
                    pro_id: this.prodId,
                    codEan: this.codEanModal,
                    pro_status: this.statusModal,
                    lojas_sugestao: this.stores.filter((s) => s.qtd_sugestao != null),
                    unidade_compra: this.isGenerico ? this.wrap : "  ",
                    embalagem: this.isGenerico ? "UN 1" : `${this.wrap.value} ${this.qtdEmbalagemModal}`,
                    vendedor_exclusivo: this.selectedBuyer ? this.selectedBuyer.value.id : null,
                };

                await axios.post(`${CONSTANTS.API_URL}/atualizarprodutonormalcliente`, data, config);
                this.loading = false;

                if (isChangingToGeneric) {
                    try {
                        const brandsResponse = await this.product_service.get_product_brands(this.product.pro_id);

                        if (!brandsResponse.data.produtos || brandsResponse.data.produtos.length === 0) {
                            await this.product_service.createBrand(this.product.pro_id);
                        }
                    } catch (error) {
                        console.error("Erro ao criar marca:", error);
                    }
                }

                this.getListaProdutos();
                this.close();
                this.$swal.fire("Editado!", "Produto editado com sucesso.", "success");
            } catch (error) {
                this.loading = false;
                this.serverMsg = error.response?.data?.mensagem || "Erro ao editar produto";
            }
        },
        cadastroProduto() {
            const config = {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            };
            const data = {
                codInterno: this.codigoModal,
                generico: this.isGenerico ? 1 : 0,
                pro_pedido_direto: this.product.pro_pedido_direto ? 1 : 0,
                unidade_compra: this.isGenerico ? this.wrap : "  ",
                descricao: this.produtoModal,
                embalagem: this.isGenerico ? "UN 1" : `${this.wrap.value} ${this.qtdEmbalagemModal}`,
                categoria: this.categoriaModal.cat_id,
                codEan: this.codEanModal,
                pro_status: this.statusModal,
                pro_sugestao: this.qtdSugestaoModal,
                lojas_sugestao: this.stores.filter((s) => s.qtd_sugestao != null),
                vendedor_exclusivo: this.selectedBuyer ? this.selectedBuyer.value.id : null,
            };

            axios
                .post(`${CONSTANTS.API_URL}/inserirprodutonormalcliente`, data, config)
                .then((res) => res.data)
                .then((res) => {
                    this.loading = false;
                    if (this.to_request) {
                        data.pro_id = res.id;
                        data.pro_ean = data.codEan;
                        data.new_amount = this.produtoQuantidadeCotacaoModal;
                        this.$emit("emit_product", data);
                    }
                    this.$swal.fire("Inserido!", "Produto inserido com sucesso.", "success");
                    this.close();
                })
                .catch((err) => {
                    this.loading = false;
                    this.serverMsg = err.response.data.mensagem;
                    if (err.response.data.valorSugestao) {
                        this.codEanModal = err.response.data.valorSugestao;
                    }
                });
        },
        getListaembalagens() {
            const config = {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            };
            return axios.get(`${CONSTANTS.API_URL}/getembalagens`, config).then((data) => {
                this.arrayEmbalagem = data.data.embalagens;
            });
        },
        getStoresProcutSuggestion() {
            const config = {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            };
            let url = `${CONSTANTS.API_URL}/v2/clients/${localStorage.getItem("cli_id")}/store/product/`;
            if (this.prodId) {
                url += this.prodId;
            }
            return axios.get(url, config).then((data) => {
                this.stores = data.data.lojas || [];
                this.loading = false;
            });
        },
        get_packaging_by_code(code) {
            return this.wraps.filter((em) => em.value === code)[0];
        },
        get_category_by_id(id) {
            return this.categories.filter((cat) => cat.cat_id === id)[0];
        },
        load_fields() {
            this.produtoModal = this.product.pro_descricao;
            this.codigoModal = this.product.pro_codInterno;
            if (this.product.pro_id) {
                this.categoriaModal = this.get_category_by_id(this.product.cat_id);
                this.qtdEmbalagemModal = this.product.pro_embalagem.split(" ")[1];
                this.statusModal = parseInt(this.product.pro_status) == 1;
                this.isGenerico = this.product.pro_generico === 1;
                this.wrap = this.isGenerico
                    ? this.product.pro_unidade_compra
                    : this.get_packaging_by_code(this.product.pro_embalagem.split(" ")[0]);
            }

            this.unidadeModal = this.product.pro_unidade_compra;
            this.prodId = this.product.pro_id;
            this.codEanModal = this.product.pro_ean;
            this.qtdSugestaoModal = this.product.pro_sugestao;
            this.getStoresProcutSuggestion();
            if (!this.product.pro_id) {
                this.getProductSuggestion();
            }
        },
        getBuyers() {
            this.selectedBuyer = undefined;
            if (!this.selectedProvider || !this.selectedProvider.value) {
                this.buyers = [{ text: "nenhum", value: {} }];
                return;
            }
            this.sellers_svc.load_sellers({ provider_id: this.selectedProvider.value.id }).then((resp) => {
                this.buyers = resp.data.map((element) => {
                    return { text: element.name, value: element };
                });
            });
        },
        load_providers() {
            this.psvc.load_providers({ related: true, noPagination: true }).then((response) => {
                this.providers.push({ text: "Nenhum", value: null });
                const providersData = response.data.data || response.data;
                providersData.forEach((p) => {
                    this.providers.push({ text: p.name, value: p });
                });
            });
        },
        getProductSuggestion() {
            this.product_service
                .get_product_suggestion()
                .then((data) => {
                    this.codEanModal = data.data.valorSugestao;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        toggle_generic(checked) {
            this.wrap = "";
            this.codigoModal = "";
            if (checked) {
                this.isGenerico = true;
                this.qtdEmbalagemModal = 1;
                this.wraps_load = this.wraps_generic;
            } else {
                this.isGenerico = false;
                this.wraps_load = this.wraps;
            }
        },
    },
    watch: {
        "wrap.value": function (new_val) {
            if (new_val == "UN") {
                this.qtdEmbalagemModal = 1;
            } else if (new_val == "DZ") {
                this.qtdEmbalagemModal = 12;
            }
        },
        selectedProvider() {
            this.getBuyers();
        },
    },
    mounted() {
        this.wraps_load = this.wraps;
        if (this.product.pro_generico == 1 || this.internal_code_only) {
            this.disabledInputs = true;
            if (this.internal_code_only) {
                this.edit_internal_code_allowed = true;
            }
        }
        this.load_providers();
        this.getListaembalagens().then(() => this.load_categories().then(() => this.load_fields()));
    },
};
</script>

<style lang="scss" scoped>
.npm-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ::v-deep(.ant-spin-nested-loading) {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    ::v-deep(.ant-spin-container) {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
}
.npm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.npm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.npm-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.npm-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
}
.npm-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 14px 16px;
}
.npm-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;

    .ant-select {
        width: 100%;
    }
}
.npm-field-wide {
    grid-column: span 2;
}
.npm-label {
    font-size: 13px;
    color: #595959;
}
.npm-required {
    color: #ff4d4f;
}
.npm-lock {
    margin-left: 6px;
    cursor: pointer;
    color: var(--primary-color);
}
.npm-lock-open {
    color: #bfbfbf;
}
.npm-error ::v-deep(.ant-select-selection),
.npm-error.ant-input {
    border-color: #ff4d4f;
}
.npm-generic-unit {
    display: flex;
    gap: 6px;

    .ant-select,
    .ant-input {
        flex: 1;
    }
}
.npm-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
    margin-top: 18px;
}
.npm-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #595959;
}
.npm-alert {
    margin-top: 16px;
}
.npm-stores {
    margin-top: 18px;
}
.npm-suggestion-input {
    width: 100px;
    text-align: center;
}
.npm-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
.npm-foot-actions {
    display: flex;
    gap: 10px;
}
</style>

<style lang="scss">
.npm-wrap {
    .ant-modal {
        min-width: 560px;
        max-width: 1100px;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
